import api from "./axios";

export async function getReserves() {
  const response = await api.get("/reserves");
  return response;
}
export async function getReserve(device_id, type) {
  const response = await api.get(`/reserves/${device_id}&${type}`);
  return response;
}

export async function postReserve(reserve) {
  const response = await api.post("/reserves", reserve);
  return response;
}

export async function deleteReserve(reserveId) {
  const response = await api.delete(`/reserves/${reserveId}`);
  return response;
}

export async function putReserve(reserve, reserveId) {
  const response = await api.put(`/reserves/${reserveId}`, reserve);
  return response;
}
